import Popup from '../plugins/PluginPopup.ts'
import Map from '../plugins/PluginMap.ts'

declare const markers: any

window.addEventListener('load', () => {
  const templatePopupHotels = document.querySelector(
    `[data-item="hotels-popup"]`,
  )
  const showPopupHotelsBtn = document.querySelector(
    `[data-popup-btn="show-hotels"]`,
  )

  if (templatePopupHotels && showPopupHotelsBtn) {
    const mapPopup = new Popup({
      trigger: 'click',
      openBtn: showPopupHotelsBtn,
      title: '',
      content: '',
      isTemplate: true,
      template: templatePopupHotels,
      iconClose: false,
      btnClose: true,
      btnCloseContent: '',
      customClass: 'popup-text',
    })
  }

  const templatePopupParking = document.querySelector(
    `[data-item="parking-popup"]`,
  )
  const showPopupParkingsBtn = document.querySelector(
    `[data-popup-btn="show-parking"]`,
  )

  if (templatePopupParking && showPopupParkingsBtn) {
    const mapPopup = new Popup({
      trigger: 'click',
      openBtn: showPopupParkingsBtn,
      title: '',
      content: '',
      isTemplate: true,
      template: templatePopupParking,
      iconClose: false,
      btnClose: true,
      btnCloseContent: '',
      customClass: 'popup-text',
    })
  }

  const templatePopupMap = document.querySelector(`[data-item="map-popup"]`)
  const showPopupMapBtn = document.querySelector(`[data-popup-btn="about-map"]`)

  if (templatePopupMap && showPopupMapBtn) {
    const mapPopup = new Popup({
      trigger: 'click',
      openBtn: showPopupMapBtn,
      title: '',
      content: '',
      isTemplate: true,
      template: templatePopupMap,
      iconClose: false,
      btnClose: true,
      btnCloseContent: '',
      customClass: 'popup-map',
      onAfterOpen() {
        const popup = document.querySelector(`[data-popup="true"]`)

        console.log(popup)
        if (popup) {
          const map_conatiner =
            popup.querySelectorAll<HTMLElement>("[data-item='map']")
          if (map_conatiner.length > 0) {
            map_conatiner.forEach((container: HTMLElement) => {
              const map = new Map(container, {
                openInPopup: true,
                accessToken: container.dataset.token,
                centerLatitude: container.dataset.lat as string,
                centerLongitude: container.dataset.lng as string,
                coordinates: markers,
              })
            })
          }
        }
      },
    })

    // console.log(popupAutoOpen)
  }

  const templatePopupStaff = document.querySelectorAll(
    `[data-item="staff-popup"]`,
  )
  const showPopupStaffBtn = document.querySelectorAll(
    `[data-popup-btn="staff-popup"]`,
  )

  if (templatePopupStaff.length !== 0 && showPopupStaffBtn.length !== 0) {
    templatePopupStaff.forEach((container, index) => {
      const staffPopup = new Popup({
        trigger: 'click',
        openBtn: showPopupStaffBtn[index],
        title: '',
        content: '',
        isTemplate: true,
        template: container,
        iconClose: false,
        btnClose: true,
        btnCloseContent: '',
        customClass: 'popup-text popup-staff',
      })
    })
  }

  const templatePopupAuto = document.querySelector(`[data-item="auto-popup"]`)

  if (templatePopupAuto) {
    const popupAutoOpen = new Popup({
      trigger: 'auto',
      openBtn: null,
      title: '',
      content: '',
      isTemplate: true,
      template: templatePopupAuto,
      iconClose: false,
      btnClose: true,
      btnCloseContent: '',
      customClass: 'popup-auto',
    })

    // console.log(popupAutoOpen)
  }
})
